import { Link } from "@/components/Elements";
import { MerchantRegisterForm } from "../components";
import { RegisterLayout } from "../components";
import { RouteConstant } from "@/routes/routeConstant";

export const MerchantRegister = () => {
  return (
    <RegisterLayout title="Create merchant account">
      <MerchantRegisterForm />
      <div className="flex justify-center mt-[5px] items-center italic text-[14px]">
        Already have an account?&nbsp;
        <Link to={RouteConstant.Login}>Sign in</Link>
      </div>
    </RegisterLayout>
  );
};
